<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <div class="main-find">
            <!-- 匹配策略 -->

            <span v-if="this.CENTER_RULE_MATCH==1">{{ $t("logs.statRule1_a9") }}:</span>

            <el-select v-model="type" placeholder="" style="width:12%;margin-right:10px" @change="rule_regex" v-if="this.CENTER_RULE_MATCH==1">
                <el-option v-for="item in typee" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <!-- 是否匹配 -->

            <span >{{ $t("logs.statRule1_a10") }}:</span>
            <el-select v-model="match" placeholder=""  style="width:12%; margin-right:10px"  @change="rule_combine">
                <el-option v-for="item in matchh" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <!-- 主机 -->
            <el-select v-model="salt_minion_ip" placeholder="" style="width:12%;margin-right:10px" v-if="this.has_min==1" @change="rule_new">
                <el-option v-for="item in salt_minion_ipp" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
        </div>
        <el-tabs @tab-click="dianji">
            <!-- 规则匹配 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.statRule1") }}
                </span>

                <div class="switch1">
                    <div class="main">

                    </div>
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')"></el-table-column>
                            <el-table-column prop="REGEX_TYPE" :label="$t('logs.statRule1_a1')"></el-table-column>
                            <el-table-column prop="REGEX" :label="$t('logs.statRule1_a2')"></el-table-column>

                            <el-table-column prop="REGEX_SCORE" :label="$t('logs.statRule1_a3')"></el-table-column>
                            <el-table-column prop="MATCHCN" :label="$t('logs.statRule1_a4')"></el-table-column>
                            <el-table-column prop="MATCHTIME" :label="$t('logs.statRule1_a6')"></el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">策略用户:</div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>

            <!-- 组合策略匹配 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.statRule2") }}
                </span>

                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')"></el-table-column>
                            <el-table-column prop="RULE" :label="$t('logs.statRule1_a7')"></el-table-column>
                            <el-table-column prop="MATCHCN" :label="$t('logs.statRule1_a4')"></el-table-column>

                            <el-table-column prop="MATCHTIME" :label="$t('logs.statRule1_a6')"></el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">策略用户:</div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 新策略匹配 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.statRule3") }}
                </span>

                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')"></el-table-column>
                            <el-table-column prop="RULE" :label="$t('logs.statRule1_a8')"></el-table-column>
                            <el-table-column prop="MATCHCN" :label="$t('logs.statRule1_a4')"></el-table-column>

                            <el-table-column prop="MATCHTIME" :label="$t('logs.statRule1_a6')"></el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">策略用户:</div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
             <!-- 组策略匹配 -->
            <el-tab-pane label>
                <span slot="label">
                    {{ $t("logs.statRule4") }}
                </span>

                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList" :row-class-name="tableRowClassName" v-loading="loading">
                            <el-table-column prop="REC" :label="$t('logs.xuhao')" width="100"></el-table-column>
                            <el-table-column prop="GROUP_NAME" :label="$t('logs.group6')"></el-table-column>
                            <el-table-column prop="SUBRULE" :label="$t('logs.Policy_list_son_new')"></el-table-column>
                            <el-table-column prop="MATCHCN" :label="$t('logs.statRule1_a4')"></el-table-column>

                            <el-table-column prop="MATCHTIME" :label="$t('logs.statRule1_a6')"></el-table-column>
                        </el-table>
                    </div>
                    
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
           
            loading: false,
            type: 2,
            typee: [],
            match: 1,
            matchh: [],
            salt_minion_ip: '127.0.0.1',
            salt_minion_ipp: [],
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44"
            }],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS"
                },
                {
                    value: "选项2",
                    label: "增加信头标记"
                },
                {
                    value: "选项3",
                    label: "强制TLS"
                }
            ],
            checked: "",
            fileList: [],
            radio: [],
            tab_num: '',
            CENTER_RULE_MATCH: '',
            has_min: ''
        };
    },
    mounted() {
        this.getFileList1()
    },
    methods: {
        rule_regex(a) {
            this.type = a
            this.getFileList1()
        },
        rule_combine(a) {
            this.match = a
            this.getFileList1()
        },
        rule_new(a) {
            this.salt_minion_ip = a
            this.getFileList1()
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
        dianji(a) {
            // console.log(a.index)
            this.tab_num = a.index
            this.getFileList1();
        },
        // 邮件数加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
           
            if (this.tab_num == 0) {
                this.tab_num = 'regex'
            } else if (this.tab_num == 1) {
                this.tab_num = 'combrule'

            } else if (this.tab_num == 2) {
                this.tab_num = 'newrule'

            }else if (this.tab_num == 3) {
                this.tab_num = 'grouprule'
            }
            
           

            this.$axios
                .get("/api/adm/cgi/report.cgi", {
                    params: {
                        __mode: "cmd_print_dump",
                        sid: sid,

                        show_type: this.tab_num,

                        type: this.type,
                        match: this.match,
                        salt_minion_ip: this.salt_minion_ip,

                    },
                })
                .then((res) => {
                    console.log(res);
                        this.loading = false

                  if(!res){
             this.loading = false;
          }
         else   if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading = false
                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList = res.data.ret.datalist;
                        this.matchh = res.data.ret.q_match;
                        this.salt_minion_ipp = res.data.ret.q_minion_host;
                        this.typee = res.data.ret.q_type;

                        this.endday = res.data.ret.endday
                        if (res.data.ret.HAS_MINION) {
                            this.has_min = 1
                        }
                        this.CENTER_RULE_MATCH = res.data.ret.CENTER_RULE_MATCH
                    }

                })

        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        }
    }
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/email_manage.less";

.table01 {

    /deep/ .has-gutter th:nth-child(1) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(3) {
        text-align: center;

    }

    /deep/ .has-gutter th:nth-child(6) {
        text-align: center;

    }

    // 表格居中位置
    /deep/ .el-table__row td:nth-child(1) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(3) {
        text-align: center;

    }

    /deep/ .el-table__row td:nth-child(6) {
        text-align: center;

    }
}

.main-find {
    // width: 100%;
    height: 50px;
    padding-left: 14px;
    // padding-bottom: 5px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: left;

    border-bottom: 2px solid #D2D7E6;
    // background: #FFFFFF;

    span {
        margin-right: 8px;

        // width: 126px;
        // display: inline-block;
        color: #0E2C5E;
    }

    .el-input {
        margin-right: 8px;
        width: 20%;
        line-height: 32px;
        height: 32px;
        // padding: 5px 10px 5px 0;

    }

    // input 框高度
    /deep/ .el-input__inner {
        height: 32px;
        padding: 0 6px;
    }

    /deep/ .el-input--suffix {
        // width: 150px;
        margin-right: 10px;
    }

    /deep/ .el-button {
        margin-right: 10px;
        // margin-left: 30px;
    }
}

//  条件下 搜索 button  按钮
.main-find /deep/ .el-button {
    padding: 8px 10px;

    background: #006BE7;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;

}

.main_style_family {

    font-family: PingFangSC-Medium, PingFang SC;
    color: #0E2C5E;
    font-size: 14px;
}
</style>
